var _defs, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3797",
    "data-name": "Path 3797",
    d: "M33.125-29a3.5,3.5,0,0,1-3.5-3.5,3.5,3.5,0,0,1,3.5-3.5,3.5,3.5,0,0,1,3.5,3.5A3.5,3.5,0,0,1,33.125-29Zm5.25,8.75h-10.5A.875.875,0,0,1,27-21.125a6.132,6.132,0,0,1,6.125-6.125,6.132,6.132,0,0,1,6.125,6.125A.875.875,0,0,1,38.375-20.25Z",
    transform: "translate(-27 36)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1893",
    "data-name": "Rectangle 1893",
    width: 17.405,
    height: 21.189,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3796",
    "data-name": "Path 3796",
    d: "M27-20.25H39.25V-36H27Z",
    transform: "translate(-27 36)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3800",
    "data-name": "Path 3800",
    d: "M10.937-35.556a6.242,6.242,0,0,1-6.25-6.222A6.242,6.242,0,0,1,10.937-48a6.242,6.242,0,0,1,6.25,6.222A6.242,6.242,0,0,1,10.937-35.556ZM20.313-20H1.562A1.559,1.559,0,0,1,0-21.556,10.926,10.926,0,0,1,10.937-32.444,10.926,10.926,0,0,1,21.875-21.556,1.559,1.559,0,0,1,20.313-20Z",
    transform: "translate(0 48)",
    fill: "none",
    clipRule: "evenodd"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1894",
    "data-name": "Rectangle 1894",
    width: 28,
    height: 34.054,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-6"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3799",
    "data-name": "Path 3799",
    d: "M0-20H22.167V-48H0Z",
    transform: "translate(0 48)",
    fill: "none"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Group_435",
    "data-name": "Group 435",
    transform: "translate(0 48)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_167",
    "data-name": "Group 167",
    transform: "translate(15.75 -41)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_166",
    "data-name": "Group 166",
    transform: "translate(-2.507 -2.459)",
    style: {
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_165",
    "data-name": "Group 165",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_164",
    "data-name": "Group 164",
    transform: "translate(2.507 2.459)",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3795",
    "data-name": "Path 3795",
    d: "M22-19.417H40.083V-41H22Z",
    transform: "translate(-24.917 38.083)",
    fill: "#a02a3a"
  })))))), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(0 -48)",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_170",
    "data-name": "Group 170",
    transform: "translate(-2.649 -3.027)",
    style: {
      isolation: "isolate"
    }
  }, _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Group_169",
    "data-name": "Group 169",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_168",
    "data-name": "Group 168",
    transform: "translate(2.649 3.027)",
    clipPath: "url(#clip-path-6)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3798",
    "data-name": "Path 3798",
    d: "M-5-19.167H22.708V-53H-5Z",
    transform: "translate(2.083 50.083)",
    fill: "#d33a51"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.0562dcd6e55eaedd290c826d858a123a.svg";
export { ForwardRef as ReactComponent };